import { render, staticRenderFns } from "./i18n.vue?vue&type=template&id=1838a1e2"
import script from "./i18n.vue?vue&type=script&lang=js"
export * from "./i18n.vue?vue&type=script&lang=js"
import style0 from "./i18n.vue?vue&type=style&index=0&id=1838a1e2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1838a1e2')) {
      api.createRecord('1838a1e2', component.options)
    } else {
      api.reload('1838a1e2', component.options)
    }
    module.hot.accept("./i18n.vue?vue&type=template&id=1838a1e2", function () {
      api.rerender('1838a1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/i18n.vue"
export default component.exports